import React from "react";
import CreateStore from "../../common/CreateEvent";

const EditStore = () => {
    return <CreateStore />;
};

export default EditStore;
